import { PositionDetail } from "./../../../components/Pages/Catalogs/Position/PositionDetail";
import { CreatePositionDto } from "../../../dtos/catalogs/position/CreatePositionDto";
import { PositionService } from "../../../services/catalogs/PositionService";
import React from "react";
import { IAppEntity } from "../../entities";
import { ReferenceTypes } from "../../../enums/ReferenceTypes";
import { NFLookupPosition } from "../../../components/Shared/NewForms/NFLookupPosition";
import PositionList from "../../../components/Pages/Catalogs/Position/PositionList";

export const Position: IAppEntity = {
  entityType: "catalog",
  title: "Position",
  pluralTitle: "Position",
  apiUrl: "Positions",
  apiEnum: ReferenceTypes.CatalogPosition,
  getDetailViewComponent(
    model: any,
    modelUpdatedEvent: (model: any) => void
  ): any {
    return React.createElement(PositionDetail, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent,
    });
  },
  getListView: (model: any, modelUpdatedEvent: (model: any) => void) =>
    React.createElement(PositionList, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent,
    }),
  getLookupComponent(model: any): any {
    return React.createElement(NFLookupPosition, {
      fieldName: model.fieldName,
      title: model.title,
      setSelectedCatalog: model.setSelectedCatalog,
    });
  },
  getDataService() {
    return new PositionService(this.apiUrl);
  },
  getEmptyModel(): CreatePositionDto {
    return {
      name: "",
      // uniqueCode: "",
      companyId: "",
      divisionId: "",
      description: "",
      dateOfApproval: new Date(),
      positionApproved: true,
      mainSalary: 0,
      mainWorkScheduleId: "",
      // mainWorkScheduleId: "",
    };
  },
};
